import { render, staticRenderFns } from "./WithdrawOffTemp.vue?vue&type=template&id=c0d641c0&scoped=true"
import script from "./WithdrawOffTemp.vue?vue&type=script&lang=js"
export * from "./WithdrawOffTemp.vue?vue&type=script&lang=js"
import style0 from "./WithdrawOffTemp.vue?vue&type=style&index=0&id=c0d641c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d641c0",
  null
  
)

export default component.exports